import React from 'react';
import Popup from '@atlaskit/popup';
import { PaginatedPickerIntlProvider } from '../common/utils';
import PaginatedAsyncSelectView from './async-select';
import formatOptionLabelDefault from './format-option-label';
import { DialogInner } from './styled';
export var Picker = function Picker(_ref) {
  var isOpen = _ref.isOpen,
      value = _ref.value,
      onClose = _ref.onClose,
      onClearValues = _ref.onClearValues,
      fieldId = _ref.fieldId,
      fieldLabel = _ref.fieldLabel,
      fieldInvalidLabel = _ref.fieldInvalidLabel,
      onChange = _ref.onChange,
      _ref$formatOptionLabe = _ref.formatOptionLabel,
      formatOptionLabel = _ref$formatOptionLabe === void 0 ? formatOptionLabelDefault : _ref$formatOptionLabe,
      onLoadOptions = _ref.onLoadOptions,
      pagination = _ref.pagination,
      PopupComponent = _ref.PopupComponent,
      onTrigger = _ref.onTrigger,
      _ref$initiallyAddSele = _ref.initiallyAddSelectedFirst,
      initiallyAddSelectedFirst = _ref$initiallyAddSele === void 0 ? true : _ref$initiallyAddSele;
  return /*#__PURE__*/React.createElement(PaginatedPickerIntlProvider, null, /*#__PURE__*/React.createElement(Popup, {
    key: fieldId,
    placement: "bottom-start",
    isOpen: isOpen,
    onClose: onClose,
    popupComponent: PopupComponent,
    trigger: onTrigger,
    autoFocus: false,
    content: function content() {
      return /*#__PURE__*/React.createElement(DialogInner, null, /*#__PURE__*/React.createElement(PaginatedAsyncSelectView, {
        field: {
          isRemovable: false,
          label: fieldLabel || '',
          invalidLabel: fieldInvalidLabel,
          type: 'Filter',
          key: fieldId,
          defaultOptionsLabel: 'defaultOptionsLabel',
          defaultOptions: true,
          cacheOptions: false,
          inputValue: 'string',
          enableShowMore: true,
          pagination: pagination,
          loadOptions: onLoadOptions
        },
        onChange: onChange,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onClear: onClearValues,
        initiallyAddSelectedFirst: initiallyAddSelectedFirst
      }));
    }
  }));
};